import { iconRemove } from "assets";
import SearchBarProduct from "components/app/search-bar/SearchBarProduct";
import { CircleCheck, CircleOff, CircleStop, CreditCard, Grid2x2, Loader, Pencil, Plus, PrinterCheck, Trash2 } from "lucide-react";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import React from "react";
import { useDispatch } from "react-redux";
import appStore from "store/appStore";
import { setIndexProductservicse } from "store/header";
import { useAppSelector } from "store/store";

const ProductServicseNavbarAction = ({
  selectProducts,
  selectedProductIds,
  allIds,
  setOpenPopoverIndex,
  setEditItemShopProduct,
  setIsApiEditAndAddProduct,
  selectedProductGroupCode,
  itemGroups,
  setId,
  setIsDialogOpenEditCategoies,
  onSubmitDeleteProdcuts,
  submitUndoDeleteShopProduct,
  setSelectProducts,
  isAllSelected,
  handleToggleSelectAll,
  setSelectedProductIds,
  handlePrint,
  loadingPrint,
  setSearchTextInput,
  view,
  changeView,
}: any) => {
  const { btnToggleProduct } = useAppSelector((state) => state.header);
  const { showDialogConfirm } = appStore();
  const dispatch = useDispatch();

  return (
    <div>
      <nav className="border-gray-200 pt-5 flex items-center justify-between ">
        <div className="flex items-center gap-3">
          {selectProducts && (
            <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
              Product Selected {selectedProductIds.length} / {allIds.length}
            </div>
          )}
          <>
            {!selectProducts ? (
              <>
                <HoverCardDetail
                  title="Create New Product or Service "
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">
                        Add a new product or service with all the necessary details to ensure accurate tracking, categorization, and visibility in your system.
                      </p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>Define the product or service name, description, and code.</li>
                        <li>Select the appropriate group or category.</li>
                        <li>Set pricing, unit, tax, and inventory information.</li>
                        <li>Ensure consistency across billing, reporting, and search filters.</li>
                      </ul>
                    </>
                  }
                >
                  <label
                    onClick={() => {
                      setOpenPopoverIndex(1);
                      setEditItemShopProduct({});
                      setIsApiEditAndAddProduct(true);
                      if (selectedProductGroupCode === "All") {
                        if (itemGroups?.data?.length) {
                          setId(itemGroups.data[0].product_group_id);
                        }
                      }
                    }}
                    className={`hover:border-3 transition-all duration-300 font-semibold rounded-full cursor-pointer lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300`}
                  >
                    <Plus className="font-semibold text-xl" />
                  </label>
                </HoverCardDetail>
                <HoverCardDetail
                  className={`${selectedProductGroupCode === "All" ? " bg-transparent border-none shadow-none" : ""} `}
                  title={selectedProductGroupCode !== "All" ? "Edit Group" : ""}
                  description={
                    selectedProductGroupCode !== "All" ? (
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">
                          Modify the details of an existing group to keep your product or service categories accurate and up-to-date.
                        </p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>Update the group name or description for clarity.</li>
                          <li>Reassign or manage products or services under this group.</li>
                          <li>Adjust group settings to reflect organizational or structural changes.</li>
                          <li>Ensure accurate reporting, filtering, and search visibility.</li>
                        </ul>
                      </>
                    ) : undefined
                  }
                >
                  <label
                    onClick={() => {
                      if (selectedProductGroupCode !== "All") {
                        setIsDialogOpenEditCategoies(true);
                      }
                    }}
                    className={`font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300 
                          ${
                            selectedProductGroupCode === "All"
                              ? "bg-gray-200 cursor-not-allowed dark:bg-accent"
                              : "cursor-pointer group hover:border-green-500 hover:border-3 transition-all duration-300"
                          }`}
                  >
                    <Pencil className="group-hover:text-green-500 font-semibold size-5" />
                  </label>
                </HoverCardDetail>
              </>
            ) : (
              <>
                {selectedProductIds.length > 0 && !btnToggleProduct ? (
                  <>
                    <HoverCardDetail
                      title="Delete Product"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Move this product to the Trash. You can recover it later if needed.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Product will be removed from active listings but not permanently deleted.</li>
                            <li>Items in Trash can be restored or permanently deleted later.</li>
                            <li>Helps prevent accidental data loss by allowing easy recovery.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        onClick={() =>
                          showDialogConfirm({
                            titileButtonSubmit: "Yes, Delete",
                            titileButtonCancel: "No, Cancel",
                            title: "Delete",
                            message: "Do you want to delete?",
                            onSubmit() {
                              onSubmitDeleteProdcuts();
                            },
                          })
                        }
                        className="group hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                   lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                      >
                        <Trash2 className="group-hover:text-red-500 transition-colors duration-300" />
                      </label>
                    </HoverCardDetail>
                  </>
                ) : (
                  btnToggleProduct && (
                    <>
                      <HoverCardDetail
                        title="Restore Product"
                        description={
                          <>
                            <p className="mb-2 font-medium text-sm dark:text-white">
                              Restore this product to its active state. Use this if the deletion was accidental or temporary.
                            </p>
                            <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                              <li>Returns the product to the catalog or listing.</li>
                              <li>Preserves all original product information.</li>
                              <li>Useful for quickly reversing bulk deletion actions.</li>
                            </ul>
                          </>
                        }
                      >
                        <label
                          onClick={() =>
                            showDialogConfirm({
                              titileButtonCancel: "No, Cancel",
                              title: "Recover",
                              message: "Do you want to recover?",
                              onSubmit() {
                                submitUndoDeleteShopProduct();
                              },
                            })
                          }
                          className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                                                   lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                        >
                          <i className="fa-solid fa-trash-can-arrow-up text-xl   transition-colors duration-300"></i>
                        </label>
                      </HoverCardDetail>

                      <HoverCardDetail
                        title="Permanently Deleted"
                        description={
                          <>
                            <p className="mb-2 font-medium text-sm dark:text-white ">
                              Permanently delete this product. This action cannot be undone and the product will be removed from the system.
                            </p>
                            <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                              <li>Removes the product entirely from your database.</li>
                              <li>It will no longer appear in reports, searches, or product listings.</li>
                              <li>Make sure the product is not in use or linked to active transactions.</li>
                            </ul>
                            {/* <p className="text-xs text-red-500 mt-1">⚠️ This is a destructive action. Proceed only if you're sure.</p> */}
                          </>
                        }
                      >
                        <label
                          onClick={() =>
                            showDialogConfirm({
                              titileButtonCancel: "No, Cancel",
                              title: "Permanance Delete",
                              message: "Do you want to permanance delete?",
                              onSubmit() {
                                onSubmitDeleteProdcuts();
                              },
                            })
                          }
                          className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                                                   lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                        >
                          <img
                            src={iconRemove}
                            className="w-7 h-7 transition duration-300 filter  group-hover:hue-rotate-[330deg] group-hover:saturate-[5] dark:invert"
                            alt="icon"
                          />
                        </label>
                      </HoverCardDetail>
                    </>
                  )
                )}
              </>
            )}
          </>

          {!selectProducts ? (
            <HoverCardDetail
              title="Select"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Select multiple products in the list to perform batch actions like deleting or saving changes.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Quickly manage multiple products at once.</li>
                    <li>Useful for bulk deletion or saving edits.</li>
                    <li>Double-check your selection before applying changes to avoid mistakes.</li>
                  </ul>
                </>
              }
            >
              <label
                htmlFor=""
                className="hover:border-3  transition-all duration-300 font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <CircleStop
                  onClick={() => {
                    dispatch(setIndexProductservicse(null));
                    setSelectProducts(true);
                  }}
                  className="text-sm"
                />
              </label>
            </HoverCardDetail>
          ) : (
            <>
              <HoverCardDetail
                title="Select All"
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Select all products in the list to perform batch actions like deleting or saving changes.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>Quickly manage multiple products at once.</li>
                      <li>Useful for bulk deletion or saving edits.</li>
                      <li>Double-check your selection before applying changes to avoid mistakes.</li>
                    </ul>
                  </>
                }
              >
                <label
                  className={`group hover:border-blue-500 hover:border-3  transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                                  flex items-center justify-center cursor-pointer border 
                                                  ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
                >
                  <CircleCheck
                    onClick={() => {
                      handleToggleSelectAll();
                    }}
                    className={`group-hover:text-white group-hover:bg-blue-500 ${
                      isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"
                    } transition-colors duration-300`}
                  />
                </label>
              </HoverCardDetail>
              <HoverCardDetail
                title="Select"
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Select multiple products in the list to perform batch actions like deleting or saving changes.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>Quickly manage multiple products at once.</li>
                      <li>Useful for bulk deletion or saving edits.</li>
                      <li>Double-check your selection before applying changes to avoid mistakes.</li>
                    </ul>
                  </>
                }
              >
                <label
                  htmlFor=""
                  className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <CircleOff
                    onClick={() => {
                      setSelectedProductIds([]);
                      setSelectProducts(false);
                    }}
                    className="text-sm"
                  />
                </label>
              </HoverCardDetail>
            </>
          )}
          {loadingPrint ? (
            <label
              onClick={() => {
                handlePrint();
              }}
              htmlFor=""
              className="hover:border-3 hover:scale-110 transition-all  duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
            >
              <Loader className="animate-spin" />
            </label>
          ) : (
            <label
              onClick={() => {
                handlePrint();
              }}
              htmlFor=""
              className="hover:border-3 hover:scale-110 transition-all  duration-300  font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
            >
              <PrinterCheck />
            </label>
          )}
        </div>

        {/* Search & View Switch */}
        <div className="flex items-center gap-2">
          <div className="flex-1 ms-4 me-2">
            <div className="relative">
              <SearchBarProduct
                onValueChange={(value) => {
                  setSearchTextInput(value);
                }}
              />
            </div>
          </div>

          {/* View Toggle Button */}
          <HoverCardDetail
            title=""
            description={
              <>
                <p className="mb-2 font-medium text-sm dark:text-white">Switch between different display modes to view your products or items.</p>
                <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                  <li>
                    <strong>Card View:</strong> Displays items as individual cards with detailed info and visuals.
                  </li>
                  <li>
                    <strong>Table View:</strong> Shows items in a compact, sortable table for easy comparison and bulk actions.
                  </li>
                  <li>Use the toggle to choose the view that best fits your task or preference.</li>
                </ul>
              </>
            }
          >
            <div className="relative">
              {view === "card" ? (
                <button
                  onClick={() => changeView("table")}
                  className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <Grid2x2 className="font-semibold size-5" />
                </button>
              ) : (
                <button
                  onClick={() => changeView("card")}
                  className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <CreditCard className="text-xl" />
                </button>
              )}
            </div>
          </HoverCardDetail>
        </div>
      </nav>
    </div>
  );
};

export default ProductServicseNavbarAction;
